class SignatureStrikeTheme {
  constructor() {
    this.body = document.body;
    this.overlay = document.querySelector('[data-site-overlay]');
    this.bindNavigation();
    this.bindAccordions();
    this.bindQuantities();
    this.bindVariants();
  }

  bindNavigation() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const close = document.querySelector('[data-menu-close]');
    if (!toggle || !drawer) return;
    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      this.overlay?.classList.toggle('is-visible', open);
      this.body.classList.toggle('menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('aria-hidden', String(!open));
    };
    toggle.addEventListener('click', () => setOpen(true));
    close?.addEventListener('click', () => setOpen(false));
    this.overlay?.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (event) => event.key === 'Escape' && setOpen(false));
  }

  bindAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('[data-accordion]');
        const open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
      });
    });
  }

  bindQuantities() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-change]');
      if (!button) return;
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const delta = Number(button.dataset.quantityChange);
      input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  bindVariants() {
    document.querySelectorAll('[data-product-form]').forEach((form) => {
      const variantSelect = form.querySelector('[data-variant-select]');
      const idInput = form.querySelector('input[name="id"]');
      if (!variantSelect || !idInput) return;
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        idInput.value = variantSelect.value;
        const button = form.querySelector('[name="add"]');
        const available = option.dataset.available === 'true';
        const comingSoon = Number(option.dataset.price) === 0;
        if (button) {
          button.disabled = !available;
          button.textContent = available ? 'Add to bag' : (comingSoon ? 'Coming soon' : 'Sold out');
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new SignatureStrikeTheme());
